import type { ButtonProps, NavigationMenuItem } from '@nuxt/ui'

export const containerMargins = ['mt-4', 'mb-12']

export const productLinks = {
  genericDrugs: { label: 'Generic Drugs', to: '/generic-drugs' },
  medicalDevices: { label: 'Medical Devices', to: '/medical-devices' },
  foodSupplements: { label: 'Food Supplements', to: '/food-supplements' },
  ppeEquipment: { label: 'PPE/Equipment', to: '/ppe-equipment' },
} satisfies Record<string, NavigationMenuItem>

export const contactEmail = {
  to: 'mailto:info@unitedmedhealth.com',
  label: 'info@unitedmedhealth.com',
} satisfies ButtonProps

export const whatsApp = {
  to: 'https://wa.me/15162343600',
  label: 'Message us on WhatsApp',
  icon: 'i-ic-baseline-whatsapp',
} satisfies ButtonProps
